import { render, staticRenderFns } from "./TeamAccessibilitySwitcher.vue?vue&type=template&id=0f956422&"
import script from "./TeamAccessibilitySwitcher.vue?vue&type=script&lang=js&"
export * from "./TeamAccessibilitySwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports